import React from "react";
import PropTypes from "prop-types";

const Label = ({
  message,
  fontSize = "0.875",
  fontWeight = "600",
  color = "black",
  htmlFor = "",
  showPointer = false,
  onClick = null,
  fontFamily = "Noto Sans",
  ...props
}) => {
  return (
    <>
      <label
        className="form-label p-0 m-0 cursor-pointer"
        htmlFor={htmlFor}
        onClick={onClick}
        style={{
          fontWeight: `${fontWeight}`,
          fontSize: `${fontSize}rem`,
          color: `${color}`,
          cursor: showPointer ? "pointer" : "",
          fontFamily: `${fontFamily}`,
          maxWidth: '-webkit-fill-available'
        }}
      >
        {message}
      </label>
    </>
  );
};

Label.propTypes = {
  message: PropTypes.string.isRequired,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.string,
};

export default Label;
